// Internal-linking hub/spoke section (Audit C H1) — CLIENT variant.
//
// Presentational cross-link block appended to product / hardware / blog pages by
// the section dispatch (components/RenderSections.js). It renders three optional
// blocks from already-resolved, region-scoped props (see resolveRelated.js):
//   (c) the hardware-overview <-> buy <-> specs cluster,
//   (a) "You may also like" related products (descriptive product-name anchors),
//   (b) "Related articles" blog <-> product cross-links.
// Headings are <Text type="h2"> (never <h1>, preserving the single-<h1> rule).
//
// components/sections/RelatedContent/Server.jsx is the BYTE-PARITY server twin
// (Text -> TextServer); keep the two in lock-step. Links use SmartLink (hard-nav
// <a>) so both variants emit identical <a> markup.

import React from 'react'
import SmartLink from '../../SmartLink'
import Text from '../../Text'
import styles from './styles.module.css'

function RelatedContent({
  familyName,
  clusterHeading,
  cluster = [],
  productsHeading,
  products = [],
  articlesHeading,
  articles = [],
}) {
  if (!cluster.length && !products.length && !articles.length) return null
  const clusterTitle = clusterHeading || `More about the ${familyName}`
  const productsTitle = productsHeading || 'You may also like'
  const articlesTitle = articlesHeading || 'Related articles'
  return (
    <section className={styles.wrapper} aria-label="Related content">
      <div className={styles.card}>
        {cluster.length > 0 && (
          <nav className={styles.block} aria-label={clusterTitle}>
            <Text type="h2" className={styles.heading}>{clusterTitle}</Text>
            <ul className={styles.links}>
              {cluster.map((c) => (
                <li key={c.href} className={styles.item}>
                  <SmartLink href={c.href} className={styles.link}>
                    {c.label}
                  </SmartLink>
                  {c.blurb ? <span className={styles.blurb}>{c.blurb}</span> : null}
                </li>
              ))}
            </ul>
          </nav>
        )}
        {products.length > 0 && (
          <div className={styles.block}>
            <Text type="h2" className={styles.heading}>{productsTitle}</Text>
            <ul className={styles.links}>
              {products.map((p) => (
                <li key={p.href} className={styles.item}>
                  <SmartLink href={p.href} className={styles.link}>
                    {p.name}
                  </SmartLink>
                  {p.blurb ? <span className={styles.blurb}>{p.blurb}</span> : null}
                </li>
              ))}
            </ul>
          </div>
        )}
        {articles.length > 0 && (
          <div className={styles.block}>
            <Text type="h2" className={styles.heading}>{articlesTitle}</Text>
            <ul className={styles.links}>
              {articles.map((a) => (
                <li key={a.href} className={styles.item}>
                  <SmartLink href={a.href} className={styles.link}>
                    {a.title}
                  </SmartLink>
                  {a.blurb ? <span className={styles.blurb}>{a.blurb}</span> : null}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}

export default RelatedContent
